import { Tooltip } from '@gilbarbara/components';
import DropdownInput from '~/components/DropdownInput';
import Gap from '~/components/Gap';
import StyledInput from '~/components/StyledInput';
import Text from '~/components/Text';
import Toggle from '~/components/Toggle';
import InfoIcon from '~/icons/InfoIcon';
import { CURRENCY_LIST } from '~/utils/amount';
import styles from './estimateform.module.scss';
import OptionSelector from './OptionSelector';
import SettingsAction from './SettingsAction';
import { IBaseSectionType } from './types';

const EstimateSettings = ({ setValue, formData }: IBaseSectionType) => {
  return (
    <div className={styles.settingsForm}>
      <Text size="md" className="bold" align="center">
        Estimate Settings
      </Text>
      <div className={`${styles.currencyWrapper} ${styles.outInput}`}>
        <div className="align-center">
          <Text size="xs">Currency</Text>
          <Gap l={8} />
          <Tooltip content="Currency will be picked from Client">
            <InfoIcon className="cursor-pointer" />
          </Tooltip>
        </div>

        <Gap t={4} />
        <Tooltip content="Currency will be picked from Client">
          <DropdownInput
            value={formData.currency}
            onChange={(newVal: any) => {
              setValue({
                currency: newVal,
              });
            }}
            options={CURRENCY_LIST}
            disabled
          />
        </Tooltip>
      </div>

      <div className={`${styles.currencyWrapper} ${styles.outInput} ${styles.setInputWrapper}`}>
        <Text size="xs">Discount</Text>
        <Gap t={4} />
        <div className="full-width align-center">
          <StyledInput
            className="full-flex attachedInput"
            value={formData.discount}
            onChange={(event: any) => {
              setValue({
                discount: event.target.value,
              });
            }}
          />

          <OptionSelector
            value={formData.discountType}
            onChange={newVal => {
              setValue({
                discountType: newVal,
              });
            }}
          />
        </div>
      </div>

      <div className={`${styles.currencyWrapper} ${styles.outInput} ${styles.setInputWrapper}`}>
        <Text size="xs">Tax</Text>
        <Gap t={4} />
        <div className="full-width align-center">
          <StyledInput
            className="full-flex attachedInput"
            value={formData.tax}
            onChange={(event: any) => {
              setValue({
                tax: event.target.value,
              });
            }}
          />

          <OptionSelector
            value={formData.taxType}
            onChange={newVal => {
              setValue({
                taxType: newVal,
              });
            }}
          />
        </div>
      </div>

      <div className={`${styles.currencyWrapper} ${styles.outInput} ${styles.setInputWrapper}`}>
        <Text size="xs">Shipping</Text>
        <Gap t={4} />
        <div className="full-width align-center">
          <StyledInput
            className="full-flex attachedInput"
            value={formData.shipping}
            onChange={(event: any) => {
              setValue({
                shipping: event.target.value,
              });
            }}
          />

          <OptionSelector
            value={formData.shippingType}
            onChange={newVal => {
              setValue({
                shippingType: newVal,
              });
            }}
          />
        </div>
      </div>

      <div className={`${styles.currencyWrapper} ${styles.outInput} ${styles.setInputWrapper}`}>
        <Text size="xs">Show shipping address in Estimate</Text>
        <Gap t={8} />
        <Toggle
          checked={formData.isShippingEnabled}
          onChange={checked => {
            setValue({
              isShippingEnabled: checked,
            });
          }}
          label={''}
        />
      </div>

      <SettingsAction templateId={formData.template_id} />
    </div>
  );
};

export default EstimateSettings;
